"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Stack_1 = __importDefault(require("../Stack"));
const Heading_1 = __importDefault(require("../Heading"));
const footer_module_scss_1 = __importDefault(require("./footer.module.scss"));
const FooterColumn = ({ children, heading = '', className = 'col-auto', withSeparator = false, }) => ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(className), children: (0, jsx_runtime_1.jsxs)(Stack_1.default, { children: [withSeparator && (0, jsx_runtime_1.jsx)("div", { className: footer_module_scss_1.default.separator }), heading && ((0, jsx_runtime_1.jsx)(Heading_1.default, { color: "white", fontSize: "sm", as: "h6", children: heading })), children] }) }));
exports.default = FooterColumn;
